export default __webpack_public_path__ + "static/media/body-detect.1e52a64b.png";